export const LOADER_BOX_STYLE = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  width: "100%",
  top: "160px",
};
